import { enableProdMode, provideZoneChangeDetection } from '@angular/core';

import { bootstrapApplication } from '@angular/platform-browser';
import { Chart } from 'chart.js';
import { initSentry } from 'shared/util/util-sentry-logging';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

Chart.defaults.font.family = "'VAGRounded_Light', sans-serif";

import config from 'devextreme/core/config';
import { licenseKey } from './devextreme-license';

console.log('licenseKey', licenseKey.substring(0, 10));
config({ licenseKey });

if (environment.enableSentry) {
  initSentry({
    dsn: 'https://250e7a0d32c854a8639bd878b423923b@o4508574371086336.ingest.de.sentry.io/4508602953105488',
    environment: environment.sentryEnv,
    // No request/response bodies in session replays: API payloads contain personal data (SF-R11 / #10165).
    networkDetailAllowUrls: [],
    ignoreErrors: ['/ResizeObserver loop/'],
    tracePropagationTargets: [
      'localhost',
      environment.api,
      environment.graphql,
    ],
    tracesSampleRate: 0.1, // Sample 10% of transactions
    replaysSessionSampleRate: 0.1, // Sample 10% of sessions
    replaysOnErrorSampleRate: 1.0, // Capture all error sessions
    maxBreadcrumbs: 50,
    release: environment.version,
  });
}

if (environment.production) {
  enableProdMode();
}

(window as any).CC = {
  version: environment.version,
};

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [provideZoneChangeDetection(), ...appConfig.providers],
})
  .then((ref) => {
    // Ensure Angular destroys itself on hot reloads.
    (window as any)['ngRef']?.destroy();

    (window as any)['ngRef'] = ref;

    // Otherwise, log the boot error
  })
  .catch((err) => console.error(err));
